export { default } from './ReactInputMultiple.jsx';
